<div class="main-wrapper authentication-wrapper">
    <div class="container-fuild">
        <div class="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
            <div class="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
                <div class="col-xxl-4 col-lg-6 col-md-6 col-11 mx-auto">
                    <div class="p-4 text-center">
                        <img src="assets/img/logo-dark.svg" alt="logo" class="img-fluid">
                    </div>
                    <div class="card authentication-card">
                        <div class="card-header">
                            <div class="text-center">
                                <h5 class="mb-1">Forgot Password</h5>
                                <p>Reset Your DreamsTour Password</p>
                            </div>
                        </div>
                        <div class="card-body">
                            <form>
                                <div class="mb-3">
                                    <label class="form-label">Email</label>
                                    <div class="input-icon">
                                        <span class="input-icon-addon">
                                            <i class="isax isax-message"></i>
                                        </span>
                                        <input type="email" class="form-control form-control-lg" placeholder="Enter Email">
                                    </div>
                                </div>
                                <div class="mb-4">
                                    <p class="text-success"><i class="isax isax-tick-circle5 me-1"></i>Reset Password Sent to “adrian&#64;example.com”</p>
                                </div>
                                <div class="mb-3">
                                    <a  [routerLink]="routes.changePassword" class="btn btn-xl btn-primary d-flex align-items-center justify-content-center w-100">Reset Password<i class="isax isax-arrow-right-3 ms-2"></i></a>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <p class="fs-14">Remember Password ? <a [routerLink]="routes.login" class="link-primary fw-medium">Sign In</a></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="coprright-footer">
        <p class="fs-14">Copyright &copy; 2025. All Rights Reserved, <a href="javascript:void(0);" class="text-primary fw-medium">DreamsTour</a></p>
    </div>
</div>